<template>
  <!-- <component
    :is="img"
    :hexCode="hexCode"
    :height="Number(size)"
    :width="Number(size)"
    :stroke="stroke"
  ></component> -->
  <component
    :is="this.icon"
    :color="hexCode"
    :size="Number(size)"
    :stroke-width="stroke"
  />
</template>

<script>
export default {
  name: "Icon",
  props: {
    icon: Function,
    hexCode: String,
    size: String,
    stroke: String,
  },
  data() {
    return {};
  },
  methods: {},
  setup() {
    return {};
  },
};
</script>

<style scoped></style>
